import { Component, OnInit } from '@angular/core';
import { faChartPie, faPlus, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'app/core/services/configuration/configuration.service';
import { FacturacionService } from 'app/core/services/facturacion/facturacion.service';
import { columnHeader } from 'app/shared/factoring-datatable/factoring-datatable.component';
import { ConfirmModalComponent } from 'app/shared/utils/confirm-modal/confirm-modal.component';
import { ManageFacturacionSeriesComponent } from '../modals/facturacion/manage-facturacion-series/manage-facturacion-series.component';
import { functions } from '../../../core/helpers/functions';

@Component({
  selector: 'app-facturacion-series',
  templateUrl: './facturacion-series.component.html',
  styleUrls: ['./facturacion-series.component.css']
})
export class FacturacionSeriesComponent implements OnInit {
  faSyncAlt  = faSyncAlt;
  faChartPie = faChartPie;
  faPlus     = faPlus;
  public rowData          : any[]   = [];
	public loadingTable     : boolean = false;
	public columnDefs       : columnHeader[];
	public pageTableActual  : number;
	public pageTableTotal   : number;
	public pageTablePerPages: number  = 10;
	public pageTablePages   : number[];
	public user             : any;
	public identidad        : any     = {};
	public searchstring     : string = '';
	public canCreate: boolean = false;

  constructor(
    private configurationService  : ConfigurationService,
    private facturacionService    : FacturacionService,
    public modalService           : NgbModal,
  ) { }

  ngOnInit(): void {
    this.obtenerSeries();
  }

  obtenerSeries(page = 1, page_size = 10) {
    this.facturacionService.obtenerSeries(page, page_size).then(resp => {
      console.log(resp);
      this.initVars();
      this.loadTable(resp);
    }, err => {
      console.error(err);
      
    })
  }

  loadTable(data) {
    this.rowData = functions.indextable( data )
    // this.rowData           = data.results
    this.pageTableActual   = data.page_number
    this.pageTableTotal    = data.count
    this.pageTablePerPages = data.per_page
    this.pageTablePages = []
    for (let index = 0; index < data.num_pages; index++) {
      this.pageTablePages.push(index)
    }
  }
    
  initVars() {
    let columns = [
      {
        headerName: 'N°', 
        field     : 'index' ,
        sortable  : true,
      },
      {
        headerName: 'Tipo', 
        field     : 'tipo_descripcion',
        class     : 'text-center',
        sortable  : true,
        // filterable: true,
        // filterProp: 'descripcion',
        // filterInput: true,
      },
      {
        headerName: 'Proceso', 
        field     : 'proceso_descripcion',
        class     : 'text-center',
        sortable  : true,
        // filterable: true,
        // filterProp: 'descripcion',
        // filterInput: true,
      },
      {
        headerName: 'Serie', 
        field     : 'serie',
        class     : 'text-center',
        sortable  : true,
        // filterable: true,
        // filterProp: 'descripcion',
        // filterInput: true,
      },
      {
        headerName: 'Número', 
        field     : 'numero',
        class     : 'text-center',
        sortable  : true,
        // filterable: true,
        // filterProp: 'descripcion',
        // filterInput: true,
      },
    ];
  
    this.columnDefs = columns;
  }

  goToPage({page,per_page,filtros}) {
    this.obtenerSeries(page, per_page);
  }

  crear() {
    const modalRef = this.modalService.open(ManageFacturacionSeriesComponent, {
    });

    modalRef.result.then((result) => {
          console.log(result);
      }, (reason) => {
          console.log(reason);
    });

    modalRef.componentInstance.successEmit.subscribe(result => {
			console.log(result);
			this.obtenerSeries();
		},
		error => {

		});
  }

  tableEditEvent(row) {
    const modalRef = this.modalService.open(ManageFacturacionSeriesComponent, {
    });

    modalRef.componentInstance.serieId = row.id;

    modalRef.result.then((result) => {
          console.log(result);
      }, (reason) => {
          console.log(reason);
    });

    modalRef.componentInstance.successEmit.subscribe(result => {
			console.log(result);
			this.obtenerSeries();
		},
		error => {
      console.error(error);
		});
  }

  destroy(row) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
		
		});

		modalRef.componentInstance.title = 'Remover Serie';
		modalRef.componentInstance.message = '¿Seguro que desea remover la Serie?';
		
		modalRef.result.then((result) => {
		if (result) {
			this.configurationService.elimiarEvaluacion(row.id)
			.then(result => {
			this.obtenerSeries();
			})
			.catch(error => {
			console.error(error);
			});
		}
		}, (reason) => {
			console.log(reason);
		});
  }

}
